module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/mv_photowedding_03@3x-084dd21d23559c2b0f0ddd6ec2be6ecc.webp";